import axios from "axios";
import { readUser } from "utils/session";

const ROSTER_PREFIX = "fleetRoster:";
let pending = null;

function cacheKey() {
  const user = readUser();
  const id = user?.userid || user?.username;
  return id ? `${ROSTER_PREFIX}${id}` : "";
}

function readCache() {
  const key = cacheKey();
  if (!key) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(key) || "null");
    if (!saved?.rosterToken || !saved.expiresAt || saved.expiresAt * 1000 <= Date.now()) {
      if (key) localStorage.removeItem(key);
      return null;
    }
    return saved;
  } catch {
    return null;
  }
}

function writeCache(saved) {
  const key = cacheKey();
  if (!key) return;
  localStorage.setItem(key, JSON.stringify(saved));
}

function withCcid(row) {
  const ccid = row.ccid != null ? String(row.ccid).trim() : "";
  if (!ccid) return row;
  return { ...row, simno: ccid };
}

function mergeRows(saved, liveRows) {
  const liveByDid = new Map(liveRows.map((row) => [String(row.did), row]));
  const previous = saved.rows || [];
  if (!previous.length) {
    const identity = new Map((saved.devices || []).map((device) => [String(device.did), device]));
    return liveRows.map((row) => {
      const known = identity.get(String(row.did));
      if (!known) return row;
      return { ...row, astid: known.aid || row.astid, did: known.did, imei: known.imei || row.imei };
    });
  }
  return previous.map((row) => {
    const live = liveByDid.get(String(row.did));
    if (!live) return row;
    return {
      ...row,
      ...live,
      astid: row.astid,
      did: row.did,
      imei: row.imei,
      branch: row.branch,
      branchName: row.branchName,
      branchCode: row.branchCode,
      AssetMapImg: row.AssetMapImg,
    };
  });
}

export function fetchFleetRows({ apiBaseUrl, userKey, forceRoster = false }) {
  if (!forceRoster && pending) return pending;
  const saved = forceRoster ? null : readCache();
  const headers = { Authorization: `Bearer ${userKey}` };
  if (saved?.rosterToken) headers["X-Fleet-Roster"] = saved.rosterToken;
  const run = axios
    .get(`${apiBaseUrl}/api/landing/currentfleetstat`, { headers })
    .then((response) => {
      const info = response.data.fleetInfo || {};
      let rows = (info.fleetdata || []).map(withCcid);
      if (info.rosterToken && info.fleetRoster) {
        writeCache({
          rosterToken: info.rosterToken,
          expiresAt: info.rosterExpiresAt,
          devices: info.fleetRoster,
          rows,
        });
      } else if (saved) {
        rows = mergeRows(saved, rows).map(withCcid);
        writeCache({ ...saved, rows });
      }
      const live = info.liveCache;
      const liveCache = live && Number.isFinite(Number(live.cache))
        ? { cache: Number(live.cache), database: Number(live.database) || 0 }
        : null;
      if (liveCache) rows.liveCache = liveCache;
      return rows;
    });
  if (forceRoster) return run;
  pending = run.finally(() => {
    pending = null;
  });
  return pending;
}
